module.exports = __webpack_public_path__ + "static/media/sy_jiaogezhong.1556d76c.png";